<template>
  <SoAlert type="info" title="Raise a Siteworks task">
    <p class="mt-3 mb-1">
      Please raise a Siteworks task on this case and fill in all required fields
      working with the customer. Advise the customer that our Siteworks team
      will need to correct their metering setup before we can book a smart meter
      exchange for them. They will reach out to the customer if they need any
      more information and to confirm when your appointment can be booked.
    </p>
  </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"

  export default defineComponent({
    components: {
      SoAlert,
    },
  })
</script>
